import React, { Component } from "react";
import Navbar from "../components/Navbar";
import AppLayout from "../Layouts/AppLayout";

import { category } from "../service/FirebaseService/CloundFireStore/model";

export default class View1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: []
    };
  }

  async componentWillMount() {
    await category.subscribe(this.handleReciveData("categories"));
  }

  handleReciveData = name => data => {
    this.setState({ [name]: data });
  };
  handleGotoCreate = () => {
    this.props.history.push("/categories/create");
  };

  handleDel = (documentId) => async () => {
    category.softDeleteById(documentId);
  }

  handleEdit = (documentId) => () => {
    this.props.history.push(`/categories/edit/${documentId}`);
  }

  renderTableBody = () => {
    return this.state.categories.map((category, index) => {
      return (
        <tr key={index}>
          <td>{category.title}</td>
          <td>
            <button
              onClick={this.handleEdit(category.documentId)}
              class="btn btn-info btn-sm"
            >
              Edit
            </button>
            <button class="btn btn-danger btn-sm ml-2" onClick={this.handleDel(category.documentId)}>
              Delete
            </button>
          </td>
        </tr>
      );
    });
  };

  render() {
    return (
      <div>
        <Navbar />
        <AppLayout>
          <div className="d-flex justify-content-end mb-2">
            <button onClick={this.handleGotoCreate} className="btn btn-success">
              Add Category
            </button>
          </div>

          <div className="card card-default">
            <div className="card-header">Categories</div>
            <div className="card-body">
              <table className="table">
                <thead>
                  <tr>
                    <th>Title</th>
                  </tr>
                </thead>
                <tbody>{this.renderTableBody()}</tbody>
              </table>
            </div>
          </div>
        </AppLayout>
      </div>
    );
  }
}
